'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevronright } from '@common/icon';
import { CustomLink } from '@/app/_components/CustomLink';
interface DonationBenefitDialogContentProps {
  govName?: string;
  giftDetailHref: string;
  hideTitle?: boolean;
}
export const DonationBenefitDialogContent = t0 => {
  const $ = _c(17);
  const {
    govName,
    giftDetailHref,
    hideTitle
  } = t0;
  const displayGovName = govName || "\uC9C0\uC790\uCCB4";
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      title: "\uC138\uC561\uACF5\uC81C",
      description: "10\uB9CC \uC6D0\uAE4C\uC9C0 \uC5F0\uB9D0\uC815\uC0B0\uC2DC 100% \uD658\uAE09"
    };
    t2 = {
      title: "\uD504\uB9AC\uBBF8\uC5C4 \uB2F5\uB840\uD488",
      description: "\uAE30\uBD80\uAE08\uC758 30% \uC9C0\uC5ED \uD2B9\uC0B0\uD488\uC744 \uD3EC\uC778\uD2B8\uB85C \uBC1B\uC544\uC694"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = `${displayGovName} 상품 전용 쿠폰으로 한 번 더 할인`;
  let t4;
  if ($[2] !== t3) {
    t4 = [t1, t2, {
      title: "\uC6F0\uB9C8\uCF19 \uC9C0\uC790\uCCB4 \uD560\uC778\uCFE0\uD3F0",
      description: t3
    }];
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const benefits = t4 as const;
  let t5;
  if ($[4] !== displayGovName || $[5] !== hideTitle) {
    t5 = hideTitle ? null : <h2 className="mb-16 font-700 text-Gray-900 typo-body1">{displayGovName}에 기부하면?</h2>;
    $[4] = displayGovName;
    $[5] = hideTitle;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== benefits) {
    t6 = <section className="bg-O-25 p-28 mobile-tablet:p-32"><dl className="flex flex-col gap-16 mobile-tablet:gap-20">{benefits.map(_temp)}</dl></section>;
    $[7] = benefits;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="mt-32 text-center font-700 text-Gray-900 typo-caption1 mobile-tablet:mt-28">쿠폰 적용하면, 지금 이 상품을{" "}<span className="text-O-400">웰마켙 최저가</span>로 구매할 수 있어요!</p>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SvgChevronright className="size-16" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== giftDetailHref) {
    t9 = <CustomLink href={giftDetailHref} className="mt-8 flex h-56 items-center justify-center gap-4 bg-O-400 font-700 text-Gray-white typo-body2 hover:opacity-80">기부하고 혜택 전부 받기{t8}</CustomLink>;
    $[11] = giftDetailHref;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t9) {
    t10 = <div className="flex flex-col">{t5}{t6}{t7}{t9}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
function _temp(benefit) {
  return <div key={benefit.title} className="flex flex-col gap-4 mobile-tablet:items-center"><dt className="font-700 text-O-400 typo-body3 mobile-tablet:typo-body4">{benefit.title}</dt><dd className="font-400 text-Gray-600 typo-body4">{benefit.description}</dd></div>;
}